<mat-card class="pageWrapper">
    <mat-card-content>
        <mat-form-field class="fullWidth" appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input>
        </mat-form-field>
        <div class="list-grid-wrap home">
            <span class="material-symbols-outlined" (click)="openSharedAccessDialog()" matTooltip="User Access">
                <mat-icon>folder_shared</mat-icon>
            </span>
            <ng-container *ngIf="isUserAuthorizedToUploadTemplate">
                <span class="list-icon" (click)="uploadUserAccessTemplate()" matTooltip="Upload Bulk ACL Template">
                    <mat-icon>upload_file</mat-icon>
                </span>
                <span class="list-icon" (click)="downloadUserAccessTemplate()" matTooltip="Download Bulk ACL Template">
                    <mat-icon>download</mat-icon>
                </span>
            </ng-container>
            <span class="list-icon" (click)="setViewStatus('list')" matTooltip="List View">
                <mat-icon>list</mat-icon>
            </span>
            <span class="grid-icon" (click)="setViewStatus('grid')" matTooltip="Grid View">
                <mat-icon>grid_view</mat-icon>
            </span>
            <span class="sort-icon" (click)="sortNamesAsc()" *ngIf="!ascSorted" matTooltip="Sort">
                <mat-icon>arrow_upward</mat-icon>
            </span>
            <span class="sort-icon" (click)="sortNamesDesc()" *ngIf="!descSorted" matTooltip="Sort">
                <mat-icon>arrow_downward</mat-icon>
            </span>
        </div>
        <div class="section-wrap">
            <mat-grid-list [cols]="isMobile ? 1 : 4" rowHeight="200px" gutterSize="30px" *ngIf="isStatusGrid">
                <mat-grid-tile *ngFor="let drive of allSharedDrivesFiltered" (click)="openDrive(drive)" style="cursor: pointer;">
                    <div class="menuHome">
                        <div>
                            <mat-icon>storage</mat-icon>
                        </div>
                        <div class="tileText">
                            {{drive.name}}
                        </div>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
            <mat-list *ngIf="!isStatusGrid">
                <mat-list-item *ngFor="let drive of allSharedDrivesFiltered" (click)="openDrive(drive)"
                    class="listHome">
                    <mat-icon matListItemIcon>storage</mat-icon>
                    <div matListItemTitle class="tileText">{{drive.name}}</div>
                </mat-list-item>
            </mat-list>
        </div>
    </mat-card-content>
</mat-card>